import { USER_ROLES } from "@/mappings/user-roles";

export default [
    {
        path: 'postback-errors',
        name: 'postback-errors',
        component: (): Promise<any> => import('@/views/events/PostbackErrors.vue'),
        meta: {
            title: 'Ошибки постбеков',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR],
        },
    },
    {
        path: 'postback-error-chart',
        name: 'postback-error-chart',
        component: (): Promise<any> => import('@/components_v3/events/PostbackErrorChart.vue'),
        meta: {
            title: 'График ошибок',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR],
        },
    },
];
